module.exports = __webpack_public_path__ + "img/marketing-budget-icon.998b3f60.svg";